import React from 'react'
import App from './App'
import ReactDOM from 'react-dom/client'
import { RecoilRoot } from 'recoil'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { initSentry } from 'src/service/utils/sentry/init'

initSentry()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

const queryClient = new QueryClient()

root.render(
  <QueryClientProvider client={queryClient}>
    <RecoilRoot>
        <App />
    </RecoilRoot>
  </QueryClientProvider>
)
